import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      coachMark: {
        GET_STARTED: 'Get Started',
        LEARN_MORE: 'Learn more',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      coachMark: {
        GET_STARTED: 'Bắt Đầu',
        LEARN_MORE: 'Tìm hiểu thêm',
      },
    },
  }),
)
